import React, { useState, Suspense } from 'react';
import { Tabs, Tab, withStyles, Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import { hasPermission } from '../../sc-utilities';

import WorkDiagnoseReport from '../../sc-diagnose/WorkDiagnoseReport';
import ReportList from './ErasureReport';

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    rootPaper: {
        width: 'auto',
        height: 'auto',
        padding: '21px',

        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        },
    },
});

const TabContainer = props => {
    return (
        <Typography component="div" dir={props.dir} style={{ paddingTop: 3 * 3 }}>
            {props.children}
        </Typography>
    );
};
function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index || props.disabled}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3} style={{ padding: '0px' }} disabled={true}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const Report = props => {
    const { classes, theme, translations, productID, onGenerate, isSingleTab, productType } = props;
    const [tabValue, setTabValue] = useState(0);

    console.log('productType', productType);

    const handleChange = (event, value) => {
        setTabValue(value);
    };

    const showErasureTab = productType !== 'HeadphoneProduct' && hasPermission(props.permissions, 'erasure_report_list');
    const showDiagnoseTab = ['PCProduct', 'HeadphoneProduct'].includes(productType) && hasPermission(props.permissions, 'diagnose_report_list');
    const showVerificationTab = !isSingleTab && productType !== 'HeadphoneProduct' && hasPermission(props.permissions, 'verification_report_list');
    const showAssetCheckTab = !isSingleTab && hasPermission(props.permissions, 'asset_check_report_list');

    // Tabs values are positional, so each index equals the number of visible tabs before it
    const erasureIndex = 0;
    const diagnoseIndex = erasureIndex + (showErasureTab ? 1 : 0);
    const verificationIndex = diagnoseIndex + (showDiagnoseTab ? 1 : 0);
    const assetCheckIndex = verificationIndex + (showVerificationTab ? 1 : 0);

    return <div className={classes.root} >
      {isSingleTab ? null : <Tabs
            value={tabValue}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
        >
            {showErasureTab && <Tab label={translations["erasure_report"] || "Erasure report"} index={erasureIndex} />}
            {showDiagnoseTab && <Tab label={translations["work_diagnose_report"] || "Diagnose report"} index={diagnoseIndex} />}
            {showVerificationTab && <Tab label={translations["verification_report"] || "Verification report"} index={verificationIndex} />}
            {showAssetCheckTab && <Tab label={translations["asset_check_report"] || "Asset check report"} index={assetCheckIndex} />}
        </Tabs>
}
        {showErasureTab && <TabPanel index={erasureIndex} value={tabValue}> <TabContainer dir={theme.direction}><Suspense fallback={<div><CircularProgress /></div>}><ReportList productID={productID} tabValue={tabValue} onGenerate={onGenerate} isSingleTab={isSingleTab} erasureReportType={'pdf'} /></Suspense></TabContainer> </TabPanel>}
        {showDiagnoseTab && <TabPanel index={diagnoseIndex} value={tabValue}> <TabContainer dir={theme.direction}><Suspense fallback={<div><CircularProgress /></div>}><WorkDiagnoseReport productID={productID} tabValue={tabValue} onGenerate={onGenerate} /></Suspense></TabContainer> </TabPanel>}
        {showVerificationTab && <TabPanel index={verificationIndex} value={tabValue}> <TabContainer dir={theme.direction}><Suspense fallback={<div><CircularProgress /></div>}><ReportList productID={productID} tabValue={tabValue} onGenerate={onGenerate} erasureReportType={'verification-pdf'} /></Suspense></TabContainer> </TabPanel>}
        {showAssetCheckTab && <TabPanel index={assetCheckIndex} value={tabValue}> <TabContainer dir={theme.direction}><Suspense fallback={<div><CircularProgress /></div>}><ReportList productID={productID} tabValue={tabValue} onGenerate={onGenerate} erasureReportType={'check-pdf'} /></Suspense></TabContainer> </TabPanel>}
    </div>
}

const mapStateToProps = state => {
    return {
        permissions: state?.core?.login?.permissions || [],
        translations: state?.translate?.translations?.activeTranslations || {},
    };
};


const mapDispatchToProps = dispatch => {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(Report));